import { useRef, useState } from "react"
import { useWindowMousePosition } from "./useMousePosition"

export function useActiveMouseInArea(): [
  boolean,
  { handleMouseEnter(): void; handleMouseLeave(): void; forceInactive(): void },
] {
  const [isMouseMoving, setIsMouseMoving] = useState(false)
  const [isHovering, setIsHovering] = useState(false)
  const mouseMoveTimeout = useRef<any | null>(null)

  useWindowMousePosition(() => {
    if (isHovering) {
      if (mouseMoveTimeout.current) {
        clearTimeout(mouseMoveTimeout.current)
      }
      if (!isMouseMoving) {
        setIsMouseMoving(true)
      }
      mouseMoveTimeout.current = setTimeout(() => setIsMouseMoving(false), 1500)
    }
  })

  function forceInactive() {
    setIsMouseMoving(false)
    setIsHovering(false)
  }

  function handleMouseEnter() {
    setIsHovering(true)
  }

  function handleMouseLeave() {
    forceInactive()
  }

  return [isMouseMoving, { handleMouseEnter, handleMouseLeave, forceInactive }]
}
